// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d77g","question":"styles_question__tIlXC","description":"styles_description__xWRoG"};